
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface StudentStats {
  present: number;
  absent: number;
  attendanceRate: string;
}

export const useStudentAttendanceStats = (studentId: string | null) => {
  return useQuery({
    queryKey: ['student-attendance-stats', studentId],
    queryFn: async () => {
      if (!studentId) return null;
      
      const { data, error } = await supabase
        .from('attendances')
        .select('status')
        .eq('student_id', studentId);
      
      if (error) throw error;
      
      const total = data?.length || 0;
      const present = data?.filter(a => a.status === 'present').length || 0;
      const absent = data?.filter(a => a.status === 'absent').length || 0;
      const attendanceRate = total > 0 ? `${Math.round((present / total) * 100)}%` : '-';
      
      return { present, absent, attendanceRate } as StudentStats;
    },
    enabled: !!studentId,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};
